import React from 'react';

import { Link } from '@ontruck/orc';
import {
  AccountManager,
  Ontime,
  ShipperName,
  TagsGroup,
} from 'modules/shipper-order/Card/components';

import { shipperInfoStyles } from './styled';

const t = {
  special_requirements: 'Special requirements',
  cif: 'CIF',
};

const ShipperInfo = ({ shipper, className }) => {
  const { company_name, isPriority, isNew, isRecovering, special_requirements, tax_number } =
    shipper;
  const { sales_attributes } = shipper;
  const { ontime_rate, owner_username } = sales_attributes || {};

  return (
    <div className={className}>
      <div className="column">
        <div className="item">
          <ShipperName name={company_name} shipperId={shipper?.id} />
        </div>
        <div className="item">
          <TagsGroup isPriority={isPriority} isRecovering={isRecovering} isNew={isNew} />
        </div>

        {!!special_requirements && (
          <div className="item last">
            <Link
              text={t.special_requirements}
              weight="bold"
              target="_blank"
              href={special_requirements}
            />
          </div>
        )}
      </div>
      <div className="column column_align-right">
        <div className="item">
          <AccountManager username={owner_username} />
        </div>
        <div className="item">
          <Ontime onTimeRate={ontime_rate} />
        </div>
        {!!tax_number && (
          <div className="item last">
            {t.cif}: {tax_number}
          </div>
        )}
      </div>
    </div>
  );
};

export default shipperInfoStyles(ShipperInfo);
